module.exports = __webpack_public_path__ + "img/henry-head.87f48e0a.png";